export interface SplitViewLayout {
  mode: 'side-by-side' | 'stacked',
  reverse: boolean
}
